import { createStoreHandle } from '@repo/sharedlib/src/utils/store.util';
import { get, writable } from 'svelte/store';
import type { DraftContent } from '@repo/common/types/Draft';

const DRAFT_FILENAME = 'draft-content.dat';

// Create store handle that automatically persists to localStorage
export const {
	store: currentDraftModel,
	itemStore: currentDraft,
	setItem: _setDraftContent,
	resetItem: clearDraftContent,
	loadStoredItem: loadDraftContent,
	scheduleUpdate: scheduleDraftUpdate
} = createStoreHandle<DraftContent>(DRAFT_FILENAME, {
	content: ''
});

// Duplex streams
const initialDraft = get(currentDraftModel)?.item ?? null;
export const draftRx = writable<DraftContent | null>(initialDraft);
export const draftTx = writable<DraftContent | null>(initialDraft);

export function setDraftRx(draft: DraftContent | null) {
	draftRx.set(draft);
}

export function setDraftTx(draft: DraftContent | null) {
	draftTx.set(draft);
}

export function clearDraftStreams() {
	draftRx.set(null);
	draftTx.set(null);
}

// Wrapper function to maintain backward compatibility with the old API
export function setDraftContent(content: DraftContent | null) {
	if (content === null) {
		clearDraftContent();
	} else {
		_setDraftContent(content);
	}
}

// Function to restore draft for a specific type (only from user drafts, not AI drafts)
export function restoreDraftForType(draftType: string): DraftContent | null {
	// Load the current draft content from user draft store only
	const draft = get(currentDraftModel)?.item;

	// Check if we have a draft of the matching type
	if (draft && draft.draftType === draftType) {
		return draft;
	}

	return null;
}
